import { defineStore } from "pinia";
import { getLanguages, getLocalizedTranslations } from "@/api/apiclient/translations";
import type { TranslationLanguage } from "@/types/translations";
import { getI18n } from "@/plugins/i18n";
import { SessionStorage } from "@/storage/index";
import { getLocalized } from "@/api/apiclient/language";
import { collectLocalizedSources } from "@/utils/localizedSources";
import { reportBootstrapError } from "@/utils/bootstrapError";

// import { getI18n, loadLocaleMessages, setI18nLanguage } from "@/i18n";
// import { setLocale } from "@vee-validate/i18n";

// import apiProvider from "api/apiProvider";
// import * as translationsApi from "api/apiclient/translations";
// import { LoadingState } from "types/enums";

// import type * as Api from "types/api";
// import type * as Store from "types/store";
// import { mapTranslationLanguage } from "mappers/translations";
// import config from "config";
// import { localStore } from "core/localStore";

interface State {
  defaultLocale: string;
  currentLocale: string;
  locales: Array<TranslationLanguage>;
  loadingState: string;
  error: unknown;
}

export const useLocale = defineStore("locale", {
  state: (): State => {
    const defaultLocale = "it-IT"; //config.defaultLocale;
    const currentLocale = "it-IT"; //config.defaultLocale;

    return {
      defaultLocale,
      currentLocale,
      locales: [],
      loadingState: "UNSET",
      error: null,
    };
  },
  actions: {
    async init(): Promise<void> {
      // const current = await localStore.getLocale();
      // if (current) {
      //   this.currentLocale = current;
      // }
    },
    async fetchLanguages(force = false): Promise<void> {
      if (this.locales.length && !force) return;
      try {
        const res = await getLanguages();
        this.locales = res;
      } catch (error: unknown) {
        console.error("fetchLanguages", error);
      }
    },
    /**
     * Carica le traduzioni dalle due sorgenti indipendenti e applica quelle
     * arrivate. Se una sola sorgente cade il degrado è parziale e viene
     * segnalato; se cadono tutte lancia, perché non ci sarebbe nulla da applicare.
     */
    async changeLanguage(locale: string): Promise<void> {
      if (!locale.trim()) throw new Error("changeLanguage: locale is required");

      const i18n = getI18n();

      const [platform, language] = await Promise.allSettled([
        getLocalizedTranslations(locale),
        getLocalized(locale) as unknown as Promise<Record<string, unknown>>,
      ]);

      const sources = [
        { name: "platform/translation/localized", result: platform },
        { name: "language/localized", result: language },
      ];
      const { messages, failed } = collectLocalizedSources(sources);

      if (failed.length === sources.length) {
        throw new Error(`changeLanguage: nessuna sorgente di traduzioni per ${locale}`);
      }

      for (const source of failed) {
        reportBootstrapError(`changeLanguage:${source.name}`, source.reason);
      }

      i18n.global.locale.value = locale;
      i18n.global.setLocaleMessage(locale, messages);
      SessionStorage.set(["locale"], locale);
      this.currentLocale = locale;
    },
  },
});
